import { createContext, useContext } from "react";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";

interface ProductCartContextModel {
    cart: CartModel | undefined | null;
    allowInstantAddToCart: boolean;
}

const defaultContext: ProductCartContextModel = {
    allowInstantAddToCart: false,
    cart: undefined,
};

export const ProductCartContext =
    createContext<ProductCartContextModel>(defaultContext);

export const useProductCartContext = (): ProductCartContextModel => {
    const context = useContext<ProductCartContextModel>(
        ProductCartContext,
    );
    if (context === undefined) {
        throw new Error("ProductCartContext is undefined.");
    }
    return context;
};
